import { AfterContentInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { RedirectionService } from '@shared/services/redirection.service';
import { show_popup, TITLE_ERROR } from '@shared/utility/popup-error';

import { InternalBuroService } from './internal-buro.service';

@Component({
  selector: 'app-internal-buro',
  templateUrl: './internal-buro.component.html',
  styleUrls: ['./internal-buro.component.css'],
})
export class InternalBuroComponent implements OnInit, AfterContentInit {
  showLoader = false;

  constructor(
    private router: Router,
    private redirect: RedirectionService,
    private internalBuroService: InternalBuroService
  ) {}

  ngOnInit() {}

  ngAfterContentInit(): void {
    this.showLoader = true;

    this.internalBuroService.startWorkflow().subscribe(
      (response) => {
        const responseMessageExceptionCode = response.response.messages.filter(
          (message) => message.key === 'Message-exception'
        );
        const redirection = response.response.messages.filter((message) => message.key === 'Redirection');
        if (responseMessageExceptionCode.length != 0 && redirection.length != 0) {
          show_popup(TITLE_ERROR, response.response.messages[0].value).then(() => {
            if (response.response.messages[1].value.startsWith('http')) {
              window.location.href = response.response.messages[1].value;
            } else {
              this.router.navigate([response.response.messages[1].value]);
            }
          });
        } else {
          this.redirect.changeMessage(response);

          this.router.navigate(['/redirect']);

          this.showLoader = false;
        }
      },
      (error) => {
        this.showLoader = false;
      }
    );
  }
}
